import { render, staticRenderFns } from "./xmgl.vue?vue&type=template&id=56a9b790&scoped=true&"
import script from "./xmgl.vue?vue&type=script&lang=js&"
export * from "./xmgl.vue?vue&type=script&lang=js&"
import style0 from "./xmgl.vue?vue&type=style&index=0&id=56a9b790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a9b790",
  null
  
)

export default component.exports